/*=========================================================================================
  File Name: i18nInstance.js
  Description: Configuração Vue-i18n adaptada para Vue 3 (Modo Compatibilidade)
==========================================================================================*/
import { createI18n } from 'vue-i18n';

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: 'default',
  messages: { default: {} },
  missing: (_loc, key) => key,
  missingWarn: false,
  fallbackWarn: false,
  silentTranslationWarn: true,
  warnHtmlInMessage: 'off',
});

export default i18n;
